import * as rx from 'rxjs';
import { array, flow, invariant, io, option, pipe, task } from '@code-expert/prelude';
export const URI = 'Observable';
export const of = 
// eslint-disable-next-line @typescript-eslint/no-deprecated
rx.of;
export const from = 
// eslint-disable-next-line @typescript-eslint/no-deprecated
rx.from;
export const Pointed = { URI, of };
export const map = 
// eslint-disable-next-line @typescript-eslint/no-deprecated
rx.map;
export const mapWithIndex = (f) => rx.map((a, i) => f(i, a));
export const Functor = { URI, map: (fa, f) => pipe(fa, map(f)) };
export const ap = (fa) => (fab) => rx.combineLatest([fab, fa]).pipe(rx.map(([f, a]) => f(a)));
export const Apply = {
    ...Functor,
    ap: (fab, fa) => pipe(fab, ap(fa)),
};
export const Applicative = {
    ...Apply,
    ...Pointed,
};
// eslint-disable-next-line @typescript-eslint/no-deprecated
export const fromArray = rx.from;
export const fromTask = rx.defer;
export const fromIO = flow(of, map(io.run));
export const fromTaskK = (f) => flow(f, rx.defer);
/**
 * Chain an Observable with an IO.
 */
export const chainIOK = (f) => rx.map(flow(f, io.run));
/**
 * Chain an Observable with an IO, but discard the result.
 */
export const chainFirstIOK = (f) => rx.tap(flow(f, io.run));
/**
 * Asynchronously chain an Observable while preserving the order of events.
 */
export const chainTaskK = (f) => rx.concatMap(flow(f, fromTask));
/**
 * Asynchronously chain an Observable, but discard the result.
 */
export const chainFirstTaskK = (f) => rx.concatMap((a) => pipe(f(a), task.as(a), fromTask));
/**
 * "Throw"-fully chain an Observable, but discard the result.
 */
export const chainFirstVoid = (f) => rx.tap(f);
export const toTask = 
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
(o) => () => new Promise((resolve, reject) => void o.subscribe({ error: reject, complete: resolve }));
export const exhaustMapTaskK = (f) => rx.exhaustMap(fromTaskK(f));
export const requireSynchronousValues = (o) => {
    const result = array.zero();
    let err = option.none;
    const sub = o.subscribe({
        next: (e) => void result.push(e),
        error: (error) => (err = option.some(error)),
    });
    if (option.isSome(err))
        throw err.value;
    invariant(sub.closed, 'Observable did not synchronously complete');
    return result;
};
//# sourceMappingURL=observable.js.map